import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Runner } from '@pixi/runner';
import { BaseTexture } from '../textures/BaseTexture.mjs';
import { DepthResource } from '../textures/resources/DepthResource.mjs';
import { MSAA_QUALITY, SCALE_MODES, MIPMAP_MODES, FORMATS, TYPES } from '@pixi/constants';
var Framebuffer = /*#__PURE__*/function () {
  function Framebuffer(width, height) {
    _classCallCheck(this, Framebuffer);
    this.width = Math.round(width || 100);
    this.height = Math.round(height || 100);
    this.stencil = false;
    this.depth = false;
    this.dirtyId = 0;
    this.dirtyFormat = 0;
    this.dirtySize = 0;
    this.depthTexture = null;
    this.colorTextures = [];
    this.glFramebuffers = {};
    this.disposeRunner = new Runner("disposeFramebuffer");
    this.multisample = MSAA_QUALITY.NONE;
  }
  _createClass(Framebuffer, [{
    key: "colorTexture",
    get: function get() {
      return this.colorTextures[0];
    }
  }, {
    key: "addColorTexture",
    value: function addColorTexture() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var texture = arguments.length > 1 ? arguments[1] : undefined;
      this.colorTextures[index] = texture || new BaseTexture(null, {
        scaleMode: SCALE_MODES.NEAREST,
        resolution: 1,
        mipmap: MIPMAP_MODES.OFF,
        width: this.width,
        height: this.height
      });
      this.dirtyId++;
      this.dirtyFormat++;
      return this;
    }
  }, {
    key: "addDepthTexture",
    value: function addDepthTexture(texture) {
      this.depthTexture = texture || new BaseTexture(new DepthResource(null, {
        width: this.width,
        height: this.height
      }), {
        scaleMode: SCALE_MODES.NEAREST,
        resolution: 1,
        width: this.width,
        height: this.height,
        mipmap: MIPMAP_MODES.OFF,
        format: FORMATS.DEPTH_COMPONENT,
        type: TYPES.UNSIGNED_SHORT
      });
      this.dirtyId++;
      this.dirtyFormat++;
      return this;
    }
  }, {
    key: "enableDepth",
    value: function enableDepth() {
      this.depth = true;
      this.dirtyId++;
      this.dirtyFormat++;
      return this;
    }
  }, {
    key: "enableStencil",
    value: function enableStencil() {
      this.stencil = true;
      this.dirtyId++;
      this.dirtyFormat++;
      return this;
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      width = Math.round(width);
      height = Math.round(height);
      if (width === this.width && height === this.height) return;
      this.width = width;
      this.height = height;
      this.dirtyId++;
      this.dirtySize++;
      for (var i = 0; i < this.colorTextures.length; i++) {
        var texture = this.colorTextures[i];
        var resolution = texture.resolution;
        texture.setSize(width / resolution, height / resolution);
      }
      if (this.depthTexture) {
        var _resolution = this.depthTexture.resolution;
        this.depthTexture.setSize(width / _resolution, height / _resolution);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposeRunner.emit(this, false);
    }
  }, {
    key: "destroyDepthTexture",
    value: function destroyDepthTexture() {
      if (this.depthTexture) {
        this.depthTexture.destroy();
        this.depthTexture = null;
        ++this.dirtyId;
        ++this.dirtyFormat;
      }
    }
  }]);
  return Framebuffer;
}();
export { Framebuffer };